import { createFileRoute } from '@tanstack/react-router';
import { CustomerProfilePage } from '../../../features/customers/pages/CustomerProfilePage';
import { usePageTitle } from '../../../lib/hooks';

export const Route = createFileRoute('/_auth/customers/$id')({
  component: CustomerProfileRoute,
});

function CustomerProfileRoute() {
  usePageTitle('Customer Profile');
  return <CustomerProfilePage />;
}
